import React, { useLayoutEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ProductContextProvider } from "../pages/pre-built/products/ProductContext";
import { UserContextProvider } from "../pages/pre-built/user-manage/UserContext";
import { ProtectedRoute } from "./ProtectedRoute";

import Invest from "../pages/Invest";

import Faq from "../pages/others/Faq";
import Regularv1 from "../pages/others/Regular-1";
import Regularv2 from "../pages/others/Regular-2";
import Terms from "../pages/others/Terms";
import UserListRegular from "../pages/pre-built/user-manage/UserListRegular";
import UserContactCard from "../pages/pre-built/user-manage/UserContactCard";
import UserDetails from "../pages/pre-built/user-manage/UserDetailsRegular";
import UserListCompact from "../pages/pre-built/user-manage/UserListCompact";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";
import SchedulerDashboard from "../pages/pre-built/user-manage/SchedulerDashboard";
import KycListRegular from "../pages/pre-built/kyc-list-regular/KycListRegular";
import KycDetailsRegular from "../pages/pre-built/kyc-list-regular/kycDetailsRegular";
import TransListBasic from "../pages/pre-built/trans-list/TransListBasic";
import TransListCrypto from "../pages/pre-built/trans-list/TransListCrypto";
import ProductCard from "../pages/pre-built/products/ProductCard";
import ProductList from "../pages/pre-built/products/ProductList";
import ProductDetails from "../pages/pre-built/products/ProductDetails";

import InvoicePrint from "../pages/pre-built/invoice/InvoicePrint";

import Error404Classic from "../pages/error/404-classic";
import Error404Modern from "../pages/error/404-modern";
import Error504Modern from "../pages/error/504-modern";
import Error504Classic from "../pages/error/504-classic";

import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";




//Procurex Pages
import BuyerOnboard from "../pages/onboard/buyer/Buyer_Onboard";

import SupplierOnboard from "../pages/onboard/supplier/Supplier-Onboard";
import MaterialCategories from "../pages/masters/MaterialCategories";
import MateralLibrary from "../pages/masters/MaterialLibrary";
import Enquiries from "../pages/enquiries/Enquiries";
import ListOfParties from "../pages/onboard/ListofParties";
import UOMMaster from "../pages/masters/UOMMaster";
import DocumentTypeMaster from "../pages/masters/DocumentTypes";
import PartyDetails from "../pages/onboard/PartyDetails";
import PartyDetailsPage from "../pages/onboard/PartyDetailsPage";

//Super Admin Pages
import AppList from "../pages/super-admin/applications/AppList";
import AppCreate from "../pages/super-admin/applications/AppCreate";
import AppDetails from "../pages/super-admin/applications/AppDetails";
import PricingList from "../pages/super-admin/pricing/PricingList";
import PricingCreate from "../pages/super-admin/pricing/PricingCreate";
import PricingDetails from "../pages/super-admin/pricing/PricingDetails";
import BundleList from "../pages/super-admin/bundles/BundleList";
import BundleCreate from "../pages/super-admin/bundles/BundleCreate";
import BundleDetails from "../pages/super-admin/bundles/BundleDetails";
import CouponList from "../pages/super-admin/coupons/CouponList";
import CouponCreate from "../pages/super-admin/coupons/CouponCreate";
import CouponDetails from "../pages/super-admin/coupons/CouponDetails";
import TaxList from "../pages/super-admin/taxes/TaxList";
import InvoiceList from "../pages/super-admin/invoices/InvoiceList";
import InvoiceCreate from "../pages/super-admin/invoices/InvoiceCreate";
import ReceivablesList from "../pages/super-admin/receivables/ReceivablesList";
import CustomerControlPanel from "../pages/super-admin/customers/CustomerControlPanel";

const Pages = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        {/* <Route element={<ProtectedRoute />}> */}
        <Route>
          <Route path="dashboard" element={<Invest />}></Route>
          <Route path="party-onboarding" element={<BuyerOnboard />}></Route>
          <Route path="supplier-onboarding" element={<SupplierOnboard />}></Route>
          <Route path="material-categories" element={<MaterialCategories />}></Route>
          <Route path="material-library" element={<MateralLibrary />}></Route>
          <Route path="uom-master" element={<UOMMaster />}></Route>
          <Route path="document-types" element={<DocumentTypeMaster />}></Route>
          <Route path="enquiries" element={<Enquiries />}></Route>
          <Route path="party-list" element={<ListOfParties />}></Route>
          <Route path="party-details" element={<PartyDetails />}></Route>
          <Route path="party-details/:id" element={<PartyDetailsPage />}></Route>

          {/* Super Admin Routes */}
          <Route path="sa-applications" element={<AppList />}></Route>
          <Route path="sa-applications/create" element={<AppCreate />}></Route>
          <Route path="sa-applications/:id" element={<AppDetails />}></Route>
          <Route path="sa-pricing" element={<PricingList />}></Route>
          <Route path="sa-pricing/create" element={<PricingCreate />}></Route>
          <Route path="sa-pricing/:id" element={<PricingDetails />}></Route>
          <Route path="sa-bundles" element={<BundleList />}></Route>
          <Route path="sa-bundles/create" element={<BundleCreate />}></Route>
          <Route path="sa-bundles/:id" element={<BundleDetails />}></Route>
          <Route path="sa-coupons" element={<CouponList />}></Route>
          <Route path="sa-coupons/create" element={<CouponCreate />}></Route>
          <Route path="sa-coupons/:id" element={<CouponDetails />}></Route>
          <Route path="sa-taxes" element={<TaxList />}></Route>
          <Route path="sa-invoices" element={<InvoiceList />}></Route>
          <Route path="sa-invoices/create" element={<InvoiceCreate />}></Route>
          <Route path="sa-receivables" element={<ReceivablesList />}></Route>
          {/* Customer list removed — managed via Party Master */}
          <Route path="sa-customers/:id/control-panel" element={<CustomerControlPanel />}></Route>

          <Route element={<UserContextProvider />} >
            <Route path="user-list-regular" element={<UserListRegular />}></Route>
            <Route path="user-list-compact" element={<UserListCompact />}></Route>
            <Route path="user-contact-card" element={<UserContactCard />}></Route>
            <Route path="user-details-regular/:userId" element={<UserDetails />}></Route>
          </Route>

          <Route >
            <Route path="user-profile-notification" element={<UserProfileNotification />} ></Route>
            <Route path="user-profile-regular" element={<UserProfileRegular />}></Route>
            <Route path="user-profile-activity" element={<UserProfileActivity />}></Route>
            <Route path="user-profile-setting" element={<UserProfileSetting />}></Route>
            <Route path="scheduler-dashboard" element={<SchedulerDashboard />}></Route>
          </Route>
         

          <Route path="kyc-list-regular" element={<KycListRegular />}></Route>
          <Route path="kyc-details-regular/:kycId" element={<KycDetailsRegular />}></Route>
          <Route path="transaction-basic" element={<TransListBasic />}></Route>
          <Route path="transaction-crypto" element={<TransListCrypto />}></Route>
          <Route element={<ProductContextProvider />}>
            <Route path="product-list" element={<ProductList />}></Route>
            <Route path="product-card" element={<ProductCard />}></Route>
            <Route path="product-details/:productId" element={<ProductDetails />}></Route>
          </Route>

          <Route path="pages">
            <Route path="terms-policy" element={<Terms />}></Route>
            <Route path="faq" element={<Faq />}></Route>
            <Route path="regular-v1" element={<Regularv1 />}></Route>
            <Route path="regular-v2" element={<Regularv2 />}></Route>
          </Route>
        </Route>
      </Route>
      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-reset" element={<ForgotPassword />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route index element={<Login />}></Route>

        <Route path="errors">
          <Route path="404-modern" element={<Error404Modern />}></Route>
          <Route path="404-classic" element={<Error404Classic />}></Route>
          <Route path="504-modern" element={<Error504Modern />}></Route>
          <Route path="504-classic" element={<Error504Classic />}></Route>
        </Route>
        <Route path="*" element={<Error404Modern />}></Route>

        <Route path="invoice-print/:invoiceId" element={<InvoicePrint />}></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
